import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/pickup'

export const pickupService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getPagedList,
};

function search(max, offset, searchFilter) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', searchFilter)
}

function getPagedList(max, offset) {
    return utilHelper.doRequest(`${relativeUrl}/?max=${max}&offset=${offset}`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}